<script>
import VBottomSheet from 'vuetify/es5/components/VBottomSheet'
export default {
  name: "YBottomSheet",
  extends: VBottomSheet,
  watch: {
    value (val) {
      this.$store.commit('ui/setDialogVisibility', val)
    }
  },
  mounted () {
    this.$store.commit('ui/setDialogVisibility', this.value)
  },
  beforeDestroy () {
    this.$store.commit('ui/setDialogVisibility', false)
  }
}
</script>